import React, {Component} from 'react'
import {connect} from 'react-redux'
import SkillLevel from '../../../common/helpers/SkillLevel'

class SpecialitiesBox extends Component {
  getSpecialityRow(skill, index) {
    return (
      <div key={index} className="row">
        <div className="col-4">{skill.SkillName}</div>
        <div className="col-4">
          <SkillLevel skillLevel={skill.SkillLevel} skillLevelLabel={skill.SkillLevelLabel} />
        </div>
      </div>
    )
  }

  getRemoteCapability(remoteCapability) {
    if(remoteCapability == null){
      return '';
    }

    return (
      <div className="row">
        <div className="col-4">{'Remote recording'}</div>
        <div className="col-4">
          {remoteCapability}
        </div>
      </div>
    )
  }

  render() {
    let assignedSkills = this.props.skills.filter(item => {
      return item.SkillLevel !== '';
    });
    let remoteCapability = this.props.remoteCapability;


    return (
      <div className="col-md-6 widget">
        <div className="title">Specialities</div>
        <div className="row">
          <div className="col">
            {assignedSkills.map((skill, index) => {
              return this.getSpecialityRow(skill, index)
            })}
            {this.getRemoteCapability(remoteCapability)}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  skills: state.skillVendorPage.currentProfile.Skills,
  remoteCapability: state.skillVendorPage.currentProfile.RemoteRecordingCapabilityLabel
})
const mapDispatchToProps = dispatch => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(SpecialitiesBox)
